import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScriptTagModule } from '@streamamg/amg-common';

export const CONFIG_TOKEN = new InjectionToken<WordpressConfiguration>('WordpressConfiguration');

export interface WordpressConfiguration {
  wordpressPath: string;
  globalSettingsUrl?: string;
  globalSettingsMapping?: {
    labels: string
  };
  pagesUrl: string[];
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ScriptTagModule,
  ],
})
export class WordpressModule {
  static forRoot(config: WordpressConfiguration): ModuleWithProviders<WordpressModule> {
    return {
      ngModule: WordpressModule,
      providers: [
        {
          provide: CONFIG_TOKEN,
          useValue: config,
        },
      ],
    };
  }
}
